import { Injectable } from '@angular/core';
import { Themes } from '@usitsdasdesign/dds-ng/shared';
import { ToastAction, ToastOptions } from '@usitsdasdesign/dds-ng/toast';
import { ToasterService, ToasterType } from '../common/toaster/toaster.service';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toasterService: ToasterService) {}

  open(options: ToastOptions): void {
    if(options.isError) {
      this.openError(options.title)
    } else {
      this.openSuccess(options.title)
    }
  }

  openSuccess(title: string, message?: string, action?: ToastAction): void {
    this.toasterService.show({
      message: title,
      type: ToasterType.success
    });
  };

  openDefault(title: string, message?: string, action?: ToastAction): void {
    this.toasterService.show({
      message: title,
      type: ToasterType.warning
    });
  };

  openError(title: string, message?: string, action?: ToastAction): void {
    this.toasterService.show({
      message: title,
      type: ToasterType.error
    });
  };
}
